import { render, staticRenderFns } from "./rosteringtype.vue?vue&type=template&id=76a3c687&scoped=true&"
import script from "./rosteringtype.vue?vue&type=script&lang=js&"
export * from "./rosteringtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a3c687",
  null
  
)

export default component.exports